<template>
  <div id="app">
    <HeaderComp />

    <main>
      <!-- Slider Area Start-->
      <div class="slider-area">
        <div class="slider-active">
          <div
            class="single-slider slider-height slider-padding sky-blue d-flex align-items-center"
          >
            <div class="container">
              <div class="row d-flex align-items-center">
                <div class="col-lg-6 col-md-9">
                  <div class="hero__caption">
                    <span data-animation="fadeInUp" data-delay=".4s">Nani App</span>
                    <h1 data-animation="fadeInUp" data-delay=".6s">
                      Send anonymous texts
                      <br />on Nani App
                    </h1>
                    <p data-animation="fadeInUp" data-delay=".8s" id="downloadText">
                      Nani chat app allows you to send anonymous texts to people
                      and even groups. Get Nani on your phone by downloading it
                      below.
                    </p>
                    <!-- Slider btn -->
                    <div class="slider-btns">
                      <!-- Hero-btn -->
                      <a data-animation="fadeInLeft" data-delay="1.0s" :href="androidLink" class>
                        <img
                          class="dl-btn"
                          src="/assets/img/download/google.png"
                          style="display:inline;"
                        />
                      </a>
                      <a data-animation="fadeInLeft" data-delay="1.0s" :href="iosLink" class="mx-3">
                        <img
                          class="dl-btn apple"
                          src="/assets/img/download/apple.svg"
                          style="display:inline;"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div
                    class="hero__img d-none d-lg-block f-right"
                    data-animation="fadeInRight"
                    data-delay="1s"
                  >
                    <img style="height: 600px;" src="assets/img/hero/hero_right.png" alt />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider slider-height slider-padding sky-blue d-flex align-items-center"
          >
            <div class="container">
              <div class="row d-flex align-items-center">
                <div class="col-lg-6 col-md-9">
                  <div class="hero__caption">
                    <span data-animation="fadeInUp" data-delay=".4s">Nani App</span>

                    <h1 data-animation="fadeInUp" data-delay=".6s">
                      Send anonymous texts
                      <br />on Nani App
                    </h1>
                    <p data-animation="fadeInUp" data-delay=".8s">
                      Nani chat app allows you to send anonymous texts to people
                      and even groups. Get Nani on your phone by downloading it
                      below.
                    </p>
                    <!-- Slider btn -->
                    <div class="slider-btns">
                      <!-- Hero-btn -->
                      <a
                        data-animation="fadeInLeft"
                        data-delay="1.0s"
                        href="industries.html"
                        class="btn radius-btn"
                      >Download</a>
                      <!-- Video Btn -->
                      <a
                        data-animation="fadeInRight"
                        data-delay="1.0s"
                        class="popup-video video-btn ani-btn"
                        href="https://www.youtube.com/watch?v=1aP-TXUpNoU"
                      >
                        <i class="fas fa-play"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div
                    class="hero__img d-none d-lg-block f-right"
                    data-animation="fadeInRight"
                    data-delay="1s"
                  >
                    <img height="600px" src="assets/img/hero/hero_right.png" alt />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Slider Area End -->
    </main>
    <FooterComp />
  </div>
</template>

<script>
import HeaderComp from "./sub/Header";
import FooterComp from "./sub/Footer";
export default {
  name: "App",
  data() {
    return {
      year: new Date().getFullYear(),
      androidLink: config.downloadLinks.android,
      iosLink: config.downloadLinks.ios
    };
  },
  components: { HeaderComp, FooterComp }
};
</script>

<style>
.dl-btn {
  height: 6em;
  animation-delay: 1s;
}
.apple {
  height: 4em;
  display: flex;
}
</style>
